import { createAction, props } from '@ngrx/store';
import { SettingsPreference, SettingsPreferenceOption, SettingsPreferences } from './units.state';

export namespace UnitsActions {
  export enum Type {
    GET_SETTINGS_PREFERENECES = '[SETTINGS] Get settings preferences',
    GET_SETTINGS_PREFERENECES_SUCCESS = '[SETTINGS] Get settings preferences success',
    GET_SETTINGS_PREFERENECES_ERROR = '[SETTINGS] Get settings preferences error',
    SET_SETTINGS_PREFERENECES = '[SETTINGS] Set settings preferences',
    SET_SETTINGS_PREFERENECES_SUCCESS = '[SETTINGS] Set settings preferences success',
    SET_SETTINGS_PREFERENECES_ERROR = '[SETTINGS] Set settings preferences error',
  }

  export const getSettingsPreferences = createAction(Type.GET_SETTINGS_PREFERENECES);

  export const getSettingsPreferencesSuccess = createAction(
    Type.GET_SETTINGS_PREFERENECES_SUCCESS,
    props<{
      preferences: SettingsPreferences;
    }>()
  );

  export const getSettingPreferencesError = createAction(Type.GET_SETTINGS_PREFERENECES_ERROR);

  export const setSettingsPreferences = createAction(
    Type.SET_SETTINGS_PREFERENECES,
    props<{
      value: SettingsPreferenceOption;
      preference: SettingsPreference;
    }>()
  );

  export const setSettingsPreferencesSuccess = createAction(
    Type.SET_SETTINGS_PREFERENECES_SUCCESS,
    props<{
      preferences: SettingsPreferences;
    }>()
  );

  export const setSettingsPreferencesError = createAction(Type.SET_SETTINGS_PREFERENECES_ERROR);
}
